import { fetchClientGraphQL } from '~/hooks/graphql.js';
import { getMinimalProductNode, getVariationProductNode } from '~/hooks/queries/use-product-data-query.js';

const getCartItemNode = `
  cartItem {
    key
    quantity
    relativeSingleUnitPrice
    subtotal
    subtotalTax
    tax
    total
    product {
      node {
        productId
        productVendor {
          name
          slug
        }
      }
    }
    subscriptionItemDetails {
      duration
      signUpFee
      subscriptionRenewalDate
      total
      name
    }
  }
`;

const getCartNode = `
  cart {
    contentsTax
    contentsTotal
    discountApplied
    discountTax
    discountTotal
    displayPricesIncludeTax
    feeTax
    feeTotal
    isEmpty
    subtotal
    subtotalTax
    total
    totalTax
    requiresPayment
    systemNotices {
      message
      noticeType
    }
    contents(first: 100) {
      productCount
      itemCount
      nodes {
        ${ getMinimalProductNode }
        ${ getVariationProductNode }
        quantity
        relativeSingleUnitPrice
        subtotal
        total
        key
        subscriptionItemDetails {
          duration
          signUpFee
          subscriptionRenewalDate
          total
          name
        }
      }
    }
    appliedCoupons {
      code
      discountAmount
    }
    bonusContent {
      stageTiers {
        name
        quota
      }
      currentTier
      currentTierDetails
      amountTillNextStage
      currentBalanceEuro
      otherMessages
    }
  }
`;

const getCartDataQuery = `query Cart { ${getCartNode} }`;

const fetchCartData = () => {
  return fetchClientGraphQL(getCartDataQuery, {}, (data) => {
    return data
  });
};

export {
  getCartNode,
  getCartItemNode,
  getCartDataQuery,
  fetchCartData,
}
